import { Component, OnInit, Input} from '@angular/core';
import { DxColorBoxModule } from 'devextreme-angular';
import { Globals } from '../../../globals';
import { AnnotationDefaults } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { TdoColorPickerEvent } from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import { DrawFont } from '../../../models/configuration/draw/annotation-defaults.model';
import { FontStyle } from '../../../models/configuration/draw/annotation-defaults.model';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ConfigurationService} from '../configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const ParamName = 'DEFAULT_GENERAL';

@Component({
  selector: 'app-draw-defaults',
  templateUrl: './draw-defaults.component.html',
  styleUrls: ['./draw-defaults.component.css']
})
export class DrawDefaultsComponent implements OnInit {
  @Input() currentStrokeColor = '#f05b41';
  @Input() currentFillColor = '#f05b41';
  @Input() currentStrokeWidth = 2;

  Widths = [];
  FontSizes = [];
  annLineCaps = [{name: 'Flat', value: 0}, {name: 'Square', value: 1}, {name: 'Round', value: 2}, {name: 'Triangle', value: 3}];
  drawFonts = DrawFont;
  fontStyles = FontStyle;
  currentLineStartCap: number;
  currentLineEndCap: number;
  currentFont: string;
  currentFontSize = 12;
  currentFontStyle: number;
  enumKeys = [];
  enumFonts = [{name: 'Arial', value: 0}, {name: 'Verdana', value: 1}, {name: 'Calibri', value: 2}, {name: 'Tahoma', value: 3}];
  enumFontStyles = [{name: 'Regular', value: 0}, {name: 'Bold', value: 1}, {name: 'Italic', value: 2}, {name: 'Underline', value: 3}, {name: 'Strikethrough', value: 4}];
  public annotationsDefaults: AnnotationDefaults;
  public drawParameter: cfgDrawParameter;

  constructor(private drawDefaultService: DrawDefaultsService, private globals: Globals, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) {
    this.enumKeys = this.annLineCaps;
    // this.enumFontStyles = Object.keys(this.fontStyles).filter(f => !isNaN(Number(f)));
  }
  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  ngOnInit(): void {

    for (let i = 1; i <= 20; i++) {
      let newWidth = {
        value: i
      }
      this.Widths.push(newWidth);
    }

    for (let i = 6; i <= 25; i++) {
      let newSize = {
        value: i
      }
      this.FontSizes.push(newSize);
    }

  this.getDrawParameters(ParamName)
    .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (!this.drawParameter) {
            this.setDefaultValues();
            return;
        }
        this.annotationsDefaults = JSON.parse(this.drawParameter.ParameterValue);
        this.currentStrokeColor = this.annotationsDefaults.strokeColor;
        this.currentStrokeWidth = this.annotationsDefaults.strokeWidth;
        this.currentLineStartCap = this.annotationsDefaults.lineStartCap;
        this.currentLineEndCap = this.annotationsDefaults.lineEndCap;
        this.currentFont = this.annotationsDefaults.font;
        this.currentFontSize = this.annotationsDefaults.fontSize;
        this.currentFontStyle = this.annotationsDefaults.fontStyle;
        this.currentFillColor = this.annotationsDefaults.fillColor;
    }, err => {
        this.setDefaultValues();
    });
  }

  setDefaultValues() {
    this.annotationsDefaults = new AnnotationDefaults();
    this.annotationsDefaults.strokeColor = '#f05b41';
    this.annotationsDefaults.fillColor = '#f05b41';
    this.annotationsDefaults.strokeWidth = 2;
    this.annotationsDefaults.fontSize = 12;
    this.annotationsDefaults.font = '0';
    this.annotationsDefaults.fontName = 'Arial';
    this.annotationsDefaults.lineStartCap = 0;
    this.annotationsDefaults.lineEndCap = 0;
    this.annotationsDefaults.fontStyle = 0;
  }
  async onApply(e) {
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = ParamName;
    const annDefaults = JSON.stringify(this.annotationsDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onStrokeColorChange(event: TdoColorPickerEvent) {
    this.currentStrokeColor = event.hex;
    this.annotationsDefaults.strokeColor = this.currentStrokeColor;
  }

  onFillColorChange(event: TdoColorPickerEvent) {
    this.currentFillColor = event.hex;
    this.annotationsDefaults.fillColor = this.currentFillColor;
  }

  onStrokeWidthChange(e: TdoDropdownChange) {
    this.currentStrokeWidth = e.value.value;
    this.annotationsDefaults.strokeWidth = this.currentStrokeWidth;
  }

  onLineStartCapChange(e) {
    this.currentLineStartCap = e.value.value;
    this.annotationsDefaults.lineStartCap = e.value.value;
  }

  onLineEndCapChange(e) {
    this.currentLineEndCap = e.value.value;
    this.annotationsDefaults.lineEndCap = e.value.value;
  }

  onFontChange(e) {
    this.currentFont = e.value.value;
    this.annotationsDefaults.fontName = e.value.name;
    this.annotationsDefaults.font = e.value.value;
  }

  onFontSizeChange(e) {
    this.currentFontSize = e.value.value;
    this.annotationsDefaults.fontSize = this.currentFontSize;
  }

  onFontStyleChange(e) {
    this.currentFontStyle = e.value.value;
    this.annotationsDefaults.fontStyle = this.currentFontStyle;
  }

  getWidth(strokeWidth: number) {
    const val = this.Widths.find(p => p.value === strokeWidth);
    if (val) {
      return val;
    }
  }

  getLineStartCap(lineStartCap: number) {
    const val = this.annLineCaps.find(p => p.value === lineStartCap);
    if (val) {
      return val;
    }
  }

  getFont(font: string) {
    const val = this.enumFonts.find(p => p.value.toString() === font.toString());
    if (val) {
      return val;
    }
  }

  getFontSize(fontSize: number) {
    const val = this.FontSizes.find(p => p.value === fontSize);
    if (val) {
      return val;
    }
  }

  getFontStyle(fontStyle: number) {
    const val = this.enumFontStyles.find(p => p.value === fontStyle);
    if (val) {
      return val;
    }
  }

  dropdownChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }
}

